import { observer } from "mobx-react";
import React, { useState } from "react";
import { Text, Button, Stack, Box, Group, Loader } from "@mantine/core";
import { Rizvoice } from "../stores/Rizvoice";
import { convertSatsToFiatString } from "../helpers/conversions";
import BasicHeader from "../cubbyComponents/dataDisplay/basicHeader";
import { IconLogout } from "@tabler/icons-react";

const Subscriptions = observer(({ rizvoice }: { rizvoice: Rizvoice }) => {
  const cubby = rizvoice.cubbyData.data;
  const [loadingStates, setLoadingStates] = useState<{
    [key: number]: boolean;
  }>({});

  // Handle activating the subscription plan
  const handleActivatePlan = (duration_in_days: number, index: number) => {
    setLoadingStates((prev) => ({ ...prev, [index]: true }));

    rizvoice.rizLife("activate-plan", {
      duration_in_days: duration_in_days,
      cubby_uuid: cubby.cubbyUuid,
    });

    setTimeout(() => {
      setLoadingStates((prev) => ({ ...prev, [index]: false }));
    }, 5000);
  };
  const {
    aliasOrShortPublicKey,
    chainBalance,
    pendingBalance,
    number_of_active_channels,
  } = cubby;
  return (
    <Stack>
      {/* <BasicHeader /> */}
      <Text size="lg">Activate Guaranteed Uptime</Text>

      <Text size="md">
        Your node {aliasOrShortPublicKey}
        {chainBalance > 0 &&
          ` has an onchain balance of ${chainBalance.toLocaleString()} satoshis`}
        {pendingBalance > 0 &&
          (chainBalance > 0 ? " and" : " has") +
            ` a pending balance of ${pendingBalance.toLocaleString()} satoshis`}
        {number_of_active_channels > 0 &&
          (chainBalance > 0 || pendingBalance > 0 ? " and" : " has") +
            ` ${number_of_active_channels} active channel${
              number_of_active_channels !== 1 ? "s" : ""
            }`}
        .
      </Text>
      <Text size="md">
        You can keep this node running 24/7 by making a lightning payment.
      </Text>
      {rizvoice.subscriptionPlans.data.map((plan: any, index: number) => (
        <Box
          key={index}
          p="md"
          style={{ border: "1px solid #e0e0e0", borderRadius: 8 }}
        >
          <Text>{plan.name}</Text>
          <Text>
            Price: {plan.price.toLocaleString()} satoshis (
            {convertSatsToFiatString(plan.price, rizvoice)})
          </Text>
          <Group mt="md">
            <Button
              onClick={() => handleActivatePlan(plan.duration_in_days, index)}
              disabled={loadingStates[index]}
            >
              {loadingStates[index] ? <Loader size="sm" /> : "Proceed "}
            </Button>
          </Group>
        </Box>
      ))}
      {/* Add the My Nodes button */}
      <Button
        maw={300}
        variant="default"
        leftSection={<IconLogout />}
        component="a"
        href="/nodes"
        size="sm"
        mb="100px"
      >
        Exit To All Nodes
      </Button>
    </Stack>
  );
});

export default Subscriptions;
